import { connect } from 'react-redux';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import { loginUser, onErrorReset } from 'Actions/loginActions';
import anime from 'animejs';
import Error from 'Components/Error';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import RootRef from '@material-ui/core/RootRef';

import Snackbar from 'Snackbar';
import { getUserRole, getAuthStatus } from './selectors';
import DefaultRedirect from '../DefaultRedirect';
import HeaderAuth from '../includes/HeaderAuth';
import LoginForm from './components/LoginForm';
import RegistrationForm from './components/RegistrationForm';
import axios from 'Axios';
import formSchema from './formSchema';
import loginFormSchema from './components/LoginForm/formSchema';

import '../../styles/login-register/login-register.scss';

class LoginRegister extends React.Component {
  form = React.createRef();
  initialFromValues = {
    email: '',
    password: '',
  };

  state = {
    showPassword: false,
    password: '',
    email: '',
    responseFromInviteUser: '',
    openSnackbar: false,
    SnackbarMsg: '',
    waiting: false,
    renderRegistrationForm: false,
    acctok: null,
    registrationData: '',
    isLoading: false,
    redirectTo: null,
  };

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.from) {
      this.setState({
        redirectTo:
          this.props.location.state.from.pathname +
          this.props.location.state.from.search,
      });
    }

    anime({
      targets: this.form.current,
      opacity: [0, 1],
      duration: 400,
      delay: 600,
      elasticity: 3,
      easing: 'linear',
    });
    this.checkForInviteExist();
    this.isFinishReg();
  }

  isFinishReg = () => {
    if (this.props.location.state) {
      if (this.props.location.state.finishMessage) {
        this.setState(
          { SnackbarMsg: this.props.location.state.finishMessage },
          this.handleOpenSnackbar
        );
      }
    }
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleLoginRegister = ({ email, password }, { setSubmitting }) => {
    if (this.props.location.pathname === '/login') {
      this.props.login(email, password, setSubmitting);
    } else {
      this.registerUser(email);
      this.setState({ waiting: true });
    }
  };

  handleOpenSnackbar = () => {
    this.setState({ openSnackbar: true });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  registerUser = username => {
    const role = 'MANUFACTURER';
    axios
      .post('invite/company', {
        email: username,
        role: role,
      })
      .then(response => {
        if (response.data) {
          this.setState(
            {
              SnackbarMsg: 'The invitation has been sent',
              responseFromInviteUser: response.data,
              email: '',
              waiting: false,
              isLoading: false,
            },
            this.handleOpenSnackbar
          );
        }
      })
      .catch(error => {
        this.setState(
          {
            SnackbarMsg: error.response
              ? error.response.data.message
              : 'Failed to connect to the database',
            isLoading: false,
            waiting: false,
          },
          this.handleOpenSnackbar
        );
      });
  };

  checkRegistrationTypeAndStep = acctok => {
    axios
      .get('registration/' + acctok)
      .then(response => {
        if (response.data) {
          this.setState({
            renderRegistrationForm: true,
            acctok: acctok,
            registrationData: response.data,
          });
        }
      })
      .catch(error => {
        this.setState(
          {
            SnackbarMsg: error.response
              ? error.response.data.message.slice(20)
              : 'Failed to connect to the database',
          },
          this.handleOpenSnackbar
        );
      });
  };
  urlParam = name => {
    let results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
      this.props.location.search
    );
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || 0;
    }
  };
  checkForInviteExist = () => {
    if (this.props.location.search.length) {
      this.setState({ isLoading: true }, () => {
        //const params = new URLSearchParams(this.props.location.search);
        const acctok = this.urlParam('acctok');
        this.checkRegistrationTypeAndStep(acctok);
      });
    }
  };

  render() {
    if (this.state.renderRegistrationForm) {
      return (
        <RegistrationForm
          acctok={this.state.acctok}
          registrationData={this.state.registrationData}
        />
      );
    }
    if (this.props.authenticated) {
      return (
        <DefaultRedirect
          role={this.props.role}
          redirectTo={this.state.redirectTo}
        />
      );
    }
    // if (!this.state.isLoading && !this.state.renderRegistrationForm) {
    return (
      <Grid container className="template-entry" justify={'space-between'}>
        <Error errors={this.props.error} onCancel={this.props.onErrorReset} />
        <Grid
          item
          lg={9}
          md={8}
          sm={6}
          xs={12}
          className={
            this.props.location.pathname === '/login'
              ? 'login-background b-entry-background'
              : 'registration-background b-entry-background'
          }
        >
          <HeaderAuth type={this.props.location.pathname} />
        </Grid>
        <RootRef rootRef={this.form}>
          <Grid
            item
            lg={3}
            md={4}
            sm={6}
            xs={12}
            className="b-entry-credentials"
          >
            <Grid container alignItems={'center'} justify={'center'}>
              <Grid item xs={11} className="b-entry-credentials-wrapper">
                {this.props.location.pathname === '/login' && (
                  <div className="b-entry-credentials-wrapper__text">
                    <h3 className="b-entry-credentials-wrapper__text t-primary-24 u-mrg-bot-30">
                      Login to your account
                    </h3>
                    <span className="b-entry-credentials-wrapper__text  t-secondary-16">
                      Enter your details below
                    </span>
                  </div>
                )}
                {this.props.location.pathname === '/registration' && (
                  <div className="b-entry-credentials-wrapper__text">
                    <h3 className="b-entry-credentials-wrapper__text t-primary-24 u-mrg-bot-30">
                      Register on Luminaire Broker
                    </h3>
                    <span className="b-entry-credentials-wrapper__text t-secondary-16">
                      Create an account and tell us your product range.
                    </span>
                  </div>
                )}
                {this.props.location.pathname === '/login' ? (
                  <Formik
                    onSubmit={this.handleLoginRegister}
                    initialValues={this.state}
                    // onBlur={this.trimOnBlur}
                    // enableReinitialize
                    validationSchema={loginFormSchema}
                  >
                    {props => (
                      <LoginForm
                        {...props}
                        location={this.props.location}
                        showPassword={this.state.showPassword}
                        handleClickShowPassword={this.handleClickShowPassword}
                        handleMouseDownPassword={this.handleMouseDownPassword}
                      />
                    )}
                  </Formik>
                ) : (
                  <Formik
                    onSubmit={this.handleLoginRegister}
                    initialValues={this.state}
                    enableReinitialize
                    validationSchema={formSchema}
                    validateOnBlur
                  >
                    {props => (
                      <LoginForm
                        {...props}
                        location={this.props.location}
                        showPassword={this.state.showPassword}
                        handleClickShowPassword={this.handleClickShowPassword}
                        handleMouseDownPassword={this.handleMouseDownPassword}
                        waiting={this.state.waiting}
                      />
                    )}
                  </Formik>
                )}
                {this.props.location.pathname === '/login' && (
                  <p className="t-secondary-16 t-align-c u-mrg-top-30">
                    <Link to="/forgot_password" className="link-bellow-button">
                      Forgot your password?
                    </Link>
                  </p>
                )}
                {this.props.location.pathname === '/registration' && (
                  <p className="t-secondary-16 t-align-c u-mrg-top-30">
                    By registering you agree to our{' '}
                    <Link
                      className="link-bellow-button"
                      to="/terms-and-conditions"
                    >
                      Terms & Conditions
                    </Link>
                    .
                  </p>
                )}
              </Grid>
            </Grid>
          </Grid>
        </RootRef>
        <Snackbar
          open={this.state.openSnackbar}
          onClose={this.handleCloseSnackbar}
          msg={this.state.SnackbarMsg}
        />
      </Grid>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  login: (username, password, setSubmitting) => {
    dispatch(loginUser(username, password, setSubmitting));
  },
  onErrorReset() {
    return dispatch(onErrorReset());
  },
  // flashMessage: (message, duration = 4000) => {
  //   dispatch(flashMessage(message, duration));
  // },
});
export default connect(
  state => ({
    error: state.login.error,
    role: getUserRole(state),
    authenticated: getAuthStatus(state),
  }),
  mapDispatchToProps
)(LoginRegister);
